

const K_SIZE = 20;

const greatPlaceStyle___ = {
  // initially any map object has left top corner at lat lng coordinates
  // it's on you to set object origin to 0,0 coordinates



  position: 'absolute',
  width: K_SIZE,
  height: K_SIZE,
  left: -K_SIZE / 2,
  top: -K_SIZE / 2,
  backgroundSize: 'cover',
  border: '5px solid #f44336',
  borderRadius: K_SIZE,
  backgroundColor: 'white',
  textAlign: 'center',
  color: '#3f51b5',
  fontSize: 16,
  fontWeight: 'bold',
  padding: 4,
  cursor: 'pointer'
};
const greatPlaceStyle = {
  // initially any map object has left top corner at lat lng coordinates
  // it's on you to set object origin to 0,0 coordinates

  WebkitTransition: '0.3s',
  transition: '0.3s',


  position: 'absolute',
  width: K_SIZE,
  height: K_SIZE,
  left: -K_SIZE / 2,
  top: -K_SIZE / 2,
  backgroundSize: 'cover',
  backgroundColor: 'white',
  borderRadius: K_SIZE,
  cursor: 'pointer',

};

const greatPlaceStyleHover = {
  ...greatPlaceStyle,
 transform: 'scale(1.8)',
 transformOrigin: 'bottom center',
  zIndex:99999
};
const greatPlaceStyleHover___ = {
  ...greatPlaceStyle,
  border: '9px solid #3f51b5',
  color: '#f44336',
  zIndex:99999
};

export {greatPlaceStyle, greatPlaceStyleHover, K_SIZE};



// WEBPACK FOOTER //
// ./src/containers/my_great_place_with_controllable_hover_styles.js